/**
 * صفحة هبوط احترافية لتسجيل المصورين في تطبيق مشهد
 * مسار: /join2 — بدون header/footer
 */
import { useState, useEffect, useRef } from 'react';
import AppIcon from '../../components/AppIcon';
import MashhadLogo from '../../components/MashhadLogo';

const APP_STORE_URL = 'https://apps.apple.com/sa/app/%D9%85%D8%B4%D9%87%D8%AF/id6762574398?l=ar';

const FEATURES = [
  {
    icon: 'ShieldCheck',
    title: 'القرار عندك',
    desc: 'لا تقبل أي طلب إلا وأنت متطمن.. كل التفاصيل والأسعار واضحة قدامك قبل لا توافق.',
    color: '#2563EB',
    bg: 'rgba(37,99,235,0.08)',
    num: '01',
  },
  {
    icon: 'Wallet',
    title: 'حقوقك محفوظة',
    desc: 'انسى سالفة ملاحقة المستحقات؛ معنا نظام دفع يضمن حقك قبل لا تبدأ التصوير.',
    color: '#F07070',
    bg: 'rgba(240,112,112,0.10)',
    num: '02',
  },
  {
    icon: 'MapPin',
    title: 'عملاءك حولك',
    desc: 'تطبيق مشهد يربطك بالعملاء في منطقتك، عشان تكون دائماً خيارهم الأول والأقرب.',
    color: '#F5C24A',
    bg: 'rgba(245,194,74,0.15)',
    num: '03',
  },
  {
    icon: 'CalendarCheck',
    title: 'تنظيم يبرد القلب',
    desc: 'كل مواعيدك وتفاصيل حجوزاتك في مكان واحد، تتفرغ للإبداع وحنا نتولى الباقي.',
    color: '#10B981',
    bg: 'rgba(16,185,129,0.10)',
    num: '04',
  },
];

const FAQS = [
  {
    q: 'هل التسجيل في المنصة بفلوس؟',
    a: 'أبداً، التسجيل مجاني! هدفنا نكبر مع بعض.',
  },
  {
    q: 'كيف أستلم أرباحي؟',
    a: 'عن طريق نظام دفع آمن وموثوق، والفلوس بتوصلك بانتظام وبكل سهولة.',
  },
  {
    q: 'أنا مصور مبتدئ، أقدر أسجل؟',
    a: 'أكيد! "مشهد" يرحب بكل المبدعين، المهم هو شغفك وعدستك.',
  },
];

/* ── زر App Store الرسمي ── */
const AppStoreBadge = ({ onClick, size = 'md' }) => {
  const heights = { sm: 44, md: 54, lg: 64 };
  const h = heights[size] || 54;
  return (
    <button
      onClick={onClick}
      aria-label="حمّل من App Store"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 12,
        background: '#000',
        color: '#fff',
        border: '1px solid rgba(255,255,255,0.15)',
        borderRadius: 14,
        paddingInline: 22,
        height: h,
        cursor: 'pointer',
        fontFamily: 'IBM Plex Sans Arabic, -apple-system, sans-serif',
        textDecoration: 'none',
        transition: 'transform 0.2s, box-shadow 0.2s',
        boxShadow: '0 4px 24px rgba(0,0,0,0.35)',
      }}
      onMouseEnter={(e) => { e.currentTarget.style.transform = 'scale(1.04)'; e.currentTarget.style.boxShadow = '0 8px 32px rgba(0,0,0,0.5)'; }}
      onMouseLeave={(e) => { e.currentTarget.style.transform = 'scale(1)'; e.currentTarget.style.boxShadow = '0 4px 24px rgba(0,0,0,0.35)'; }}
    >
      {/* Apple Logo SVG */}
      <svg width="22" height="27" viewBox="0 0 814 1000" fill="white" xmlns="http://www.w3.org/2000/svg">
        <path d="M788.1 340.9c-5.8 4.5-108.2 62.2-108.2 190.5 0 148.4 130.3 200.9 134.2 202.2-.6 3.2-20.7 71.9-68.7 141.9-42.8 61.6-87.5 123.1-155.5 123.1s-85.5-39.5-164-39.5c-76 0-103.7 40.8-165.9 40.8s-105-57.8-155.5-127.4C46 790.8 0 663.6 0 541.8c0-207.2 135.1-316.7 268.1-316.7 70.5 0 129.3 46.3 173.7 46.3 42.8 0 109.7-49 189.2-49 30.5 0 108.2 2.6 168.9 75.4zm-225.1-191.7c31.8-38.1 54.5-91.5 54.5-145 0-7.1-.6-14.3-1.9-20.7-50.6 1.9-110.8 33.7-147.1 75.8-28.5 32.4-55.1 85.8-55.1 140 0 7.8 1.3 15.6 1.9 18.1 3.2.6 8.4 1.3 13.6 1.3 45.4 0 102.5-30.4 134.1-69.5z"/>
      </svg>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', lineHeight: 1.2 }}>
        <span style={{ fontSize: 11, fontWeight: 400, opacity: 0.8, letterSpacing: 0.2 }}>Download on the</span>
        <span style={{ fontSize: 22, fontWeight: 700, letterSpacing: -0.3 }}>App Store</span>
      </div>
    </button>
  );
};

const PhotographerJoin2 = () => {
  const [openFaq, setOpenFaq] = useState(0);
  const [visible, setVisible] = useState({});
  const sectionsRef = useRef({});

  useEffect(() => {
    const obs = new IntersectionObserver(
      (entries) => entries.forEach((e) => {
        if (e.isIntersecting) setVisible((v) => ({ ...v, [e.target.dataset.section]: true }));
      }),
      { threshold: 0.12 }
    );
    Object.values(sectionsRef.current).forEach((el) => el && obs.observe(el));
    return () => obs.disconnect();
  }, []);

  const setRef = (key) => (el) => { sectionsRef.current[key] = el; };
  const openAppStore = () => window.open(APP_STORE_URL, '_blank', 'noopener,noreferrer');

  return (
    <div
      className="min-h-screen bg-white text-slate-900 overflow-x-hidden"
      dir="rtl"
      style={{ fontFamily: 'IBM Plex Sans Arabic, sans-serif' }}
    >

      {/* ═══════════════════════════ HERO ═══════════════════════════ */}
      <section className="relative min-h-screen flex flex-col justify-center overflow-hidden">

        {/* خلفية */}
        <div className="absolute inset-0" style={{ background: 'linear-gradient(150deg,#060D1F 0%,#0D1F4A 40%,#1A3672 100%)' }} />

        {/* نسيج دقيق */}
        <div className="absolute inset-0 opacity-[0.04]"
          style={{ backgroundImage: 'url("data:image/svg+xml,%3Csvg width=\'60\' height=\'60\' viewBox=\'0 0 60 60\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cg fill=\'none\' fill-rule=\'evenodd\'%3E%3Cg fill=\'%23ffffff\' fill-opacity=\'1\'%3E%3Cpath d=\'M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z\'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")', backgroundSize: '60px 60px' }}
        />

        {/* توهجات */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute top-[-20%] right-[-10%] w-[600px] h-[600px] rounded-full blur-[120px] opacity-25"
            style={{ background: 'radial-gradient(circle, #2563EB, transparent 65%)' }} />
          <div className="absolute bottom-[-15%] left-[-5%] w-[500px] h-[500px] rounded-full blur-[100px] opacity-20"
            style={{ background: 'radial-gradient(circle, #F07070, transparent 65%)' }} />
          <div className="absolute top-[30%] left-[20%] w-[350px] h-[350px] rounded-full blur-[80px] opacity-15"
            style={{ background: 'radial-gradient(circle, #F5C24A, transparent 65%)' }} />
        </div>

        {/* خطوط ديكورية */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none opacity-10">
          <div className="absolute top-0 right-[30%] w-px h-full"
            style={{ background: 'linear-gradient(to bottom, transparent, rgba(255,255,255,0.4), transparent)' }} />
          <div className="absolute top-0 left-[45%] w-px h-full"
            style={{ background: 'linear-gradient(to bottom, transparent, rgba(255,255,255,0.2), transparent)' }} />
        </div>

        <div className="relative max-w-5xl mx-auto px-6 sm:px-10 py-20 sm:py-28 flex flex-col items-center text-center text-white">

          {/* الشعار */}
          <div className="mb-10 opacity-0 animate-[fadeSlideDown_0.8s_ease_0.1s_forwards]">
            <MashhadLogo variant="light" size="lg" logoType="footer" />
          </div>

          {/* بادج */}
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-white/15 bg-white/8 backdrop-blur-sm mb-8 opacity-0 animate-[fadeSlideUp_0.7s_ease_0.2s_forwards]">
            <span className="relative flex h-2.5 w-2.5">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75" />
              <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-emerald-400" />
            </span>
            <span className="text-xs sm:text-sm font-medium text-white/85 tracking-wide">
              منصة المصورين الأولى في المملكة
            </span>
          </div>

          {/* H1 */}
          <h1 className="font-black leading-[1.15] mb-8 opacity-0 animate-[fadeSlideUp_0.8s_ease_0.3s_forwards]"
            style={{ fontSize: 'clamp(2.2rem, 7vw, 5rem)' }}>
            <span
              className="block"
              style={{
                backgroundImage: 'linear-gradient(100deg, #F5C24A 0%, #F09050 50%, #F07070 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
              }}
            >
              مكانك اللي تستحقه
            </span>
            <span className="block text-white/80" style={{ fontSize: '0.7em', fontWeight: 700 }}>
              في عالم التصوير.
            </span>
          </h1>

          {/* العنوان الفرعي — مقسّم بوضوح */}
          <div className="max-w-xl mb-10 space-y-4 opacity-0 animate-[fadeSlideUp_0.8s_ease_0.45s_forwards]">
            <p className="text-lg sm:text-xl font-semibold text-white/70 leading-relaxed">
              تعبت من حوسة المواعيد؟
              <span className="mx-1 text-white/40">·</span>
              والبحث عن عملاء؟
              <span className="mx-1 text-white/40">·</span>
              وتعب التفاوض؟
            </p>
            <p className="text-base sm:text-lg text-white/60 leading-[1.9]">
              <span className="text-white font-bold">مشهد..</span>{' '}
              منصة متكاملة صممناها خصيصاً للمصورين الشغوفين،
              <br className="hidden sm:block" />
              يوصلك من خلالها العميل وتضمن لك حقوقك وتفرّغك للإبداع.
            </p>
          </div>

          {/* موكاب الجوالين */}
          <div className="relative mt-12 sm:mt-14 w-full max-w-xs sm:max-w-md opacity-0 animate-[fadeSlideUp_1s_ease_0.65s_forwards]">
            {/* ظل تحت الجوالين */}
            <div className="absolute -bottom-6 left-1/2 -translate-x-1/2 w-[75%] h-12 blur-3xl rounded-full opacity-50"
              style={{ background: 'radial-gradient(ellipse, #2563EB, transparent 70%)' }} />

            <div className="flex items-end justify-center gap-3 sm:gap-5">

              {/* الجوال الأول */}
              <div
                className="relative flex-shrink-0 overflow-hidden border-[5px] border-white/15 shadow-2xl shadow-black/60"
                style={{
                  width: '44%',
                  maxWidth: 180,
                  background: '#1a1a2e',
                  borderRadius: '1.6rem',
                  transform: 'rotate(-4deg) translateY(-14px)',
                }}
              >
                <div className="absolute top-2 left-1/2 -translate-x-1/2 w-[34%] h-[10px] rounded-full bg-black z-10" />
                <img
                  src="/assets/app-screen-1.png"
                  alt="شاشة تطبيق مشهد"
                  className="w-full object-cover object-top"
                  style={{ aspectRatio: '9/19.5', display: 'block' }}
                />
              </div>

              {/* الجوال الثاني — في المقدمة */}
              <div
                className="relative flex-shrink-0 overflow-hidden border-[5px] border-white/20 shadow-2xl shadow-black/70 z-10"
                style={{
                  width: '48%',
                  maxWidth: 196,
                  background: '#1a1a2e',
                  borderRadius: '1.6rem',
                  transform: 'rotate(3deg)',
                }}
              >
                <div className="absolute top-2 left-1/2 -translate-x-1/2 w-[34%] h-[10px] rounded-full bg-black z-10" />
                <img
                  src="/assets/app-screen-2.png"
                  alt="شاشة إدارة الحجوزات"
                  className="w-full object-cover object-top"
                  style={{ aspectRatio: '9/19.5', display: 'block' }}
                />
              </div>
            </div>
          </div>

          {/* CTA */}
          <div className="flex flex-col items-center gap-5 mt-12 sm:mt-14 opacity-0 animate-[fadeSlideUp_0.8s_ease_0.85s_forwards]">
            <p className="text-sm text-white/55 leading-relaxed max-w-sm">
              حمّل تطبيق <span className="text-white font-semibold">"مشهد"</span> الحين،
              وسجّل عشان تكون أول خيار للعملاء حولك
            </p>
            <AppStoreBadge onClick={openAppStore} size="lg" />
          </div>

          {/* سهم للتمرير */}
          <div className="absolute bottom-8 left-1/2 -translate-x-1/2 opacity-0 animate-[fadeSlideUp_1s_ease_1.2s_forwards]">
            <div className="flex flex-col items-center gap-1 animate-bounce">
              <span className="text-[10px] text-white/30 tracking-widest uppercase">scroll</span>
              <AppIcon name="ChevronDown" size={18} className="text-white/30" />
            </div>
          </div>
        </div>
      </section>

      {/* ════════════ WHY US ════════════ */}
      <section
        ref={setRef('why')} data-section="why"
        className="relative py-20 sm:py-32 px-6 sm:px-10 bg-white"
      >
        {/* خط أفقي زخرفي */}
        <div className="absolute top-0 inset-x-0 h-px"
          style={{ background: 'linear-gradient(90deg, transparent, rgba(37,99,235,0.15), transparent)' }} />

        <div className="max-w-6xl mx-auto">

          {/* عنوان القسم */}
          <div className={`mb-14 sm:mb-20 transition-all duration-700 ${visible.why ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}>
            <h2 className="text-3xl sm:text-5xl font-black text-slate-900 leading-tight max-w-xl">
              كل اللي تحتاجه عشان تكبر..
              <br />
              <span style={{ color: '#2563EB' }}>في مكان واحد</span>
            </h2>
          </div>

          {/* المميزات — قائمة عمودية فاخرة */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-px bg-slate-100 rounded-3xl overflow-hidden shadow-sm">
            {FEATURES.map((f, i) => (
              <div
                key={f.title}
                className={`group bg-white p-8 sm:p-10 flex gap-6 sm:gap-8 items-start transition-all duration-500 hover:bg-slate-50/80 ${
                  visible.why ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
                }`}
                style={{ transitionDelay: visible.why ? `${i * 90}ms` : '0ms' }}
              >
                {/* رقم */}
                <div className="flex-shrink-0 pt-1">
                  <span
                    className="text-4xl sm:text-5xl font-black leading-none select-none"
                    style={{
                      backgroundImage: `linear-gradient(135deg, ${f.color}55, ${f.color}22)`,
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                      backgroundClip: 'text',
                    }}
                  >
                    {f.num}
                  </span>
                </div>

                {/* المحتوى */}
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-3 mb-3">
                    <div
                      className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-300"
                      style={{ background: f.bg }}
                    >
                      <AppIcon name={f.icon} size={20} style={{ color: f.color }} />
                    </div>
                    <h3 className="text-lg sm:text-xl font-bold text-slate-900">{f.title}</h3>
                  </div>
                  <p className="text-sm sm:text-base text-slate-500 leading-relaxed">{f.desc}</p>

                  {/* خط ملون سفلي عند hover */}
                  <div
                    className="mt-5 h-0.5 w-0 group-hover:w-12 transition-all duration-500 rounded-full"
                    style={{ background: f.color }}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ════════════ FAQ ════════════ */}
      <section
        ref={setRef('faq')} data-section="faq"
        className="relative py-20 sm:py-32 px-6 sm:px-10 overflow-hidden"
        style={{ background: 'linear-gradient(175deg, #f8faff 0%, #eef3ff 100%)' }}
      >
        {/* دائرة زخرفية كبيرة */}
        <div className="absolute -top-32 -right-32 w-[500px] h-[500px] rounded-full blur-[80px] opacity-30 pointer-events-none"
          style={{ background: 'radial-gradient(circle, #dbeafe, transparent 70%)' }} />

        <div className="relative max-w-3xl mx-auto">

          <div className={`mb-12 sm:mb-16 transition-all duration-700 ${visible.faq ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}>
            <h2 className="text-3xl sm:text-5xl font-black text-slate-900">
              أسئلة تدور في بالك؟
            </h2>
          </div>

          <div className="space-y-3">
            {FAQS.map((item, i) => {
              const isOpen = openFaq === i;
              return (
                <div
                  key={i}
                  className={`rounded-2xl overflow-hidden transition-all duration-500 ${
                    isOpen
                      ? 'shadow-xl shadow-blue-100/60'
                      : 'shadow-sm hover:shadow-md'
                  } ${visible.faq ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}
                  style={{
                    background: isOpen ? '#fff' : '#fff',
                    border: isOpen ? '1.5px solid rgba(37,99,235,0.2)' : '1.5px solid #e2e8f0',
                    transitionDelay: visible.faq ? `${i * 80}ms` : '0ms',
                  }}
                >
                  <button
                    onClick={() => setOpenFaq(isOpen ? -1 : i)}
                    className="w-full flex items-center justify-between gap-4 px-6 py-5 text-right"
                  >
                    <span className="text-base sm:text-lg font-bold text-slate-800 flex-1 text-right">
                      {item.q}
                    </span>
                    <div
                      className="w-9 h-9 rounded-xl flex items-center justify-center transition-all duration-400 flex-shrink-0"
                      style={{
                        background: isOpen ? '#2563EB' : '#f1f5f9',
                        color: isOpen ? '#fff' : '#64748b',
                        transform: isOpen ? 'rotate(45deg)' : 'rotate(0deg)',
                      }}
                    >
                      <AppIcon name="Plus" size={16} />
                    </div>
                  </button>

                  <div className={`grid transition-all duration-400 ease-[cubic-bezier(0.4,0,0.2,1)] ${isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'}`}>
                    <div className="overflow-hidden">
                      <div className="mx-6 mb-5 pt-1 border-t border-slate-100">
                        <p className="pt-4 text-sm sm:text-base text-slate-500 leading-relaxed">{item.a}</p>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* ════════════ FINAL CTA ════════════ */}
      <section
        ref={setRef('cta')} data-section="cta"
        className="relative py-24 sm:py-36 px-6 sm:px-10 overflow-hidden"
        style={{ background: 'linear-gradient(150deg,#060D1F 0%,#0D1F4A 50%,#1A3672 100%)' }}
      >
        {/* توهجات */}
        <div className="absolute inset-0 pointer-events-none overflow-hidden">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full blur-[100px] opacity-20"
            style={{ background: 'radial-gradient(circle, #2563EB, transparent)' }} />
          <div className="absolute -top-20 right-0 w-80 h-80 rounded-full blur-[70px] opacity-20"
            style={{ background: 'radial-gradient(circle, #F5C24A, transparent)' }} />
          <div className="absolute -bottom-20 left-0 w-80 h-80 rounded-full blur-[70px] opacity-20"
            style={{ background: 'radial-gradient(circle, #F07070, transparent)' }} />
        </div>

        {/* خطوط ديكورية */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none opacity-10">
          <div className="absolute top-0 right-[25%] w-px h-full"
            style={{ background: 'linear-gradient(to bottom, transparent, rgba(255,255,255,0.5), transparent)' }} />
          <div className="absolute top-0 left-[35%] w-px h-full"
            style={{ background: 'linear-gradient(to bottom, transparent, rgba(255,255,255,0.3), transparent)' }} />
        </div>

        <div className={`relative max-w-3xl mx-auto text-center text-white transition-all duration-700 ${visible.cta ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>

          {/* أيقونة */}
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-2xl mb-10 border border-white/10"
            style={{ background: 'rgba(245,194,74,0.15)', backdropFilter: 'blur(8px)' }}>
            <AppIcon name="Camera" size={38} style={{ color: '#F5C24A' }} />
          </div>

          <h2 className="font-black leading-tight mb-6" style={{ fontSize: 'clamp(1.8rem,5vw,3.5rem)' }}>
            لا تخلي فرصتك تضيع..
            <br />
            <span style={{
              backgroundImage: 'linear-gradient(100deg, #F5C24A, #F07070)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
            }}>
              الآلاف ينتظرون لمسة إبداعك
            </span>
          </h2>

          <p className="text-base sm:text-lg text-white/60 mb-12 max-w-lg mx-auto leading-relaxed">
            حمّل "مشهد" الآن وابدأ رحلتك مع أكبر منصة للمصورين في السعودية
          </p>

          <div className="flex flex-col items-center gap-4">
            <AppStoreBadge onClick={openAppStore} size="lg" />
            <p className="text-xs text-white/35 mt-2">متاح للأجهزة الذكية · iPhone و iPad</p>
          </div>
        </div>
      </section>

      {/* ════════════ FOOTER ════════════ */}
      <footer className="bg-[#030712] py-8 px-6 text-center">
        <div className="max-w-4xl mx-auto flex flex-col items-center gap-3">
          <MashhadLogo variant="light" size="sm" logoType="footer" />
          <p className="text-xs text-slate-600">
            © {new Date().getFullYear()} منصة مشهد · جميع الحقوق محفوظة
          </p>
        </div>
      </footer>

      {/* ════════════ KEYFRAMES ════════════ */}
      <style>{`
        @keyframes fadeSlideUp {
          from { opacity: 0; transform: translateY(24px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @keyframes fadeSlideDown {
          from { opacity: 0; transform: translateY(-18px); }
          to   { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
};

export default PhotographerJoin2;
